import { Syllabus, SyllabusExternal } from '@/kontent/content-types'
import { getSyllabusTitleWithPublicationYear } from '@/utils/syllabus/getSyllabusTitleWithPublicationYear'
import { useMemo, useRef } from 'react'

type SyllabusExternalLinkProps = {
	item: SyllabusExternal | Syllabus
	refreshListener?: boolean
}

function SyllabusExternalLink({ item: syllabus }: SyllabusExternalLinkProps) {
	const ref = useRef<HTMLDivElement>()

	const syllabusTitleWithPublicationYear = useMemo(
		() => getSyllabusTitleWithPublicationYear(syllabus, false),
		[syllabus],
	)

	return (
		<div ref={ref}>
			<a
				href={syllabus.elements.redirecturl.value}
				target="_blank"
				rel="noreferrer noopener"
			>
				<span className="font-bold">
					{syllabusTitleWithPublicationYear}
				</span>
			</a>
		</div>
	)
}

export default SyllabusExternalLink
